import { Util } from './_util.js';
import gatewayDefault from './gateway.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import Swiper from 'swiper/bundle';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

const App = {
  checkTouchDevice: function () {
    if ("ontouchstart" in document.documentElement){
      $("body").addClass('touch-device');
    }
  },

  controlAnimation: function () {
    $(window).on("resize", function() {
      $("body").addClass("no-animation");
      setTimeout(function(){
          $(".no-animation").removeClass("no-animation");
      }, 200);
    }).resize();
  },

  controlHeader: function () {
    $(window).on('scroll', function(){
      const scrollTop = $(document).scrollTop();
      if ((scrollTop > 25)) {
        $('.header').addClass('header--blur');
      } else {
        $('.header').removeClass('header--blur');
      }
    }).scroll();
  },

  initGateway: function () {
    //<![CDATA[
    window.fpglobals = {
      cookeDomain: 'localhost'
    };

    window.fpglobals.gateway = new calilily_Gateway({
      cookie: 'localhost-visited'
    });

    fpglobals.gateway.init();
    //]]>
  },

  hideAgeGate: function () {
    $(document).ready(function(){
      if(!$('.age-gate-module').is(":visible")) {
        $('html').removeClass('hidden');
      }
    });
  },

  getCopyrightYear: function () {
    const currentTime = new Date(),
          currentYear = currentTime.getFullYear();
    $('.footer .year').html(currentYear);
  },

  controlMainMenu: function () {
    function openMainMenu() {
      $('.header').addClass('header--open');
      $('.main-menu').scrollTop(0);
      $('.main-menu__toggle-btn').addClass('main-menu__toggle-btn--close');
      $('html').addClass('hidden');
    }

    function closeMainMenu() {
      $('.header').removeClass('header--open');
      $('.main-menu__toggle-btn').removeClass('main-menu__toggle-btn--close');
      $('html').removeClass('hidden');
    }

    $('.main-menu__toggle-btn').on('click',function(){
      if($(this).hasClass('main-menu__toggle-btn--close')){
        closeMainMenu();
      } else {
        openMainMenu();
      }
    });
  },

  initGSAP: function () {
    const articlesImageModule = gsap.utils.toArray('.articles-module__image'),
          articlesGridFeaturedModule = gsap.utils.toArray('.articles-grid-module__item--featured'),
          bannerModuleBG = gsap.utils.toArray('.banner-module__bg'),
          biosModule = gsap.utils.toArray('.bios-module'),
          biosModuleBG = gsap.utils.toArray('.bios-module__bg'),
          calloutModule = gsap.utils.toArray('.callout-module'),
          faqIntroModule = gsap.utils.toArray('.faq-module__intro'),
          featuredProductsModule = gsap.utils.toArray('.featured-products-module__grid'),
          filterModule = gsap.utils.toArray('.filter-module'),
          findModule = gsap.utils.toArray('.find-module'),
          heroModule = gsap.utils.toArray('.hero-module'),
          highlightModule = gsap.utils.toArray('.highlight-module'),
          infographicDetailsModule = gsap.utils.toArray('.infographic-module__item--details'),
          infographicOverviewModule = gsap.utils.toArray('.infographic-module__item--overview'),
          introModule = gsap.utils.toArray('.intro-module'),
          introModuleBG = gsap.utils.toArray('.intro-module__bg');
    let matchMedia = gsap.matchMedia();


    matchMedia.add(
      {
        isDesktop: '(min-width: 981px)',
        isTablet: '(max-width: 980px) and (min-width: 761px)',
        isMobile: '(max-width: 760px)',
      },
      (context) => {
        let { isDesktop, isTablet, isMobile } = context.conditions;

        articlesImageModule.forEach((section) => {
          gsap.to(section, {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '-10',
            ease: 'sine',
          });
        });

        articlesGridFeaturedModule.forEach((section) => {
          gsap.to(section.querySelectorAll('.articles-grid-module__item-image--featured'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '-10',
            ease: 'sine',
          });
        });

        calloutModule.forEach((section) => {
          const calloutTimeline = gsap.timeline({
            scrollTrigger: {
              pin: section,
              anticipatePin: 1,
              trigger: section,
              scrub: 1,
              start: "top top",
              end: "bottom top",
              invalidateOnRefresh: true,
            },
          });

          calloutTimeline.to(section.querySelectorAll('.callout-module__bg'), {
            width: '100vw',
            height: '100vh',
            ease: 'sine',
          },'start').to(section.querySelectorAll('h1'), {
            color: '#555042',
            ease: 'sine',
          },'start').to(section.querySelectorAll('h2'), {
            opacity: '1',
            delay: 0.2,
          },'start').to(section.querySelectorAll('.callout-module__sensation'), {
            opacity: '1',
            ease: 'sine',
            delay: 0.5,
          },'start').to(section.querySelectorAll('.callout-module__activities'), {
            opacity: '1',
            ease: 'sine',
            delay: 0.8,
          },'start').to(section.querySelectorAll('.callout-module__bg'), {
            opacity: '1',
            ease: 'sine',
            delay: 1.1,
          },'start');
        });

        bannerModuleBG.forEach((section) => {
          gsap.to(section, {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '35',
            ease: 'sine',
          });
        });

        biosModule.forEach((section) => {
          gsap.to(section.querySelectorAll('.bios-module__gummy--primary'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '200',
            ease: 'sine',
          });
          gsap.to(section.querySelectorAll('.bios-module__gummy--secondary'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '150',
            ease: 'sine',
          });
        });

        biosModuleBG.forEach((section) => {
          gsap.to(section, {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '35',
            ease: 'sine',
          });
        });

        faqIntroModule.forEach((section) => {
          gsap.to(section.querySelectorAll('h1'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            y: '-100',
            ease: 'sine',
          });
        });

        featuredProductsModule.forEach((section) => {
          const featuredProductsTimeline = gsap.timeline({
            scrollTrigger: {
              pin: section,
              anticipatePin: 1,
              trigger: section,
              scrub: 1,
              start: "top top",
              end: "+=300%",
              invalidateOnRefresh: true,
            },
          });

          featuredProductsTimeline.to(section.querySelectorAll('.featured-products-module__item--2'), {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            ease: 'sine',
            delay: 0.2,
          }).to(section.querySelectorAll('.featured-products-module__item--3'), {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            ease: 'sine',
            delay: 0.2,
          }).to(section.querySelectorAll('.featured-products-module__item--3'), {
            ease: 'sine',
            delay: 0.2,
          });
        });

        filterModule.forEach((section) => {
          gsap.to(section.querySelectorAll('.filter-module__gummy--primary'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '200',
            ease: 'sine',
          });
          gsap.to(section.querySelectorAll('.filter-module__gummy--secondary'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '150',
            ease: 'sine',
          });
        });

        findModule.forEach((section) => {
          gsap.to(section.querySelectorAll('.find-module__gummy--primary'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '200',
            ease: 'sine',
          });
          gsap.to(section.querySelectorAll('.find-module__gummy--secondary'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '150',
            ease: 'sine',
          });
        });

        heroModule.forEach((section) => {
          gsap.to(section.querySelectorAll('.hero-module__image'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '20',
            ease: 'sine',
          });
        });

        highlightModule.forEach((section) => {
          gsap.to(section.querySelectorAll('.highlight-module__image--primary'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '-10',
            ease: 'sine',
          });
          gsap.to(section.querySelectorAll('.highlight-module__image--secondary'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '-40',
            ease: 'sine',
          });
          gsap.to(section.querySelectorAll('.highlight-module__gummy'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '40',
            ease: 'sine',
          });
        });

        infographicDetailsModule.forEach((section) => {
          gsap.to(section.querySelectorAll('.infographic-module__item-image'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '-10',
            ease: 'sine',
          });
        });

        infographicOverviewModule.forEach((section) => {
          gsap.to(section.querySelectorAll('.infographic-module__item-primary-graphic'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '-10',
            ease: 'sine',
          });
          gsap.to(section.querySelectorAll('.infographic-module__item-highlight'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '-20',
            ease: 'sine',
          });
          gsap.to(section.querySelectorAll('.infographic-module__item-secondary-graphic'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '20',
            ease: 'sine',
          });
        });

        introModule.forEach((section) => {
          gsap.to(section.querySelectorAll('.intro-module__gummy--primary'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '200',
            ease: 'sine',
          });
          gsap.to(section.querySelectorAll('.intro-module__gummy--secondary'), {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '150',
            ease: 'sine',
          });
        });

        introModuleBG.forEach((section) => {
          gsap.to(section, {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '35',
            ease: 'sine',
          });
        });
      }
    );
  },

  initSwipers: function () {
    $('.coming-soon-module__swiper').each(function (index) {
      const navigationVar = 's'+index;
      $(this).find('.swiper-pagination').addClass(navigationVar);
      const comingSoonSwiper = new Swiper($(this)[0], {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        slidesPerView: 'auto',
        speed: 1000,
        autoplay: {
          delay: 5000,
        },
        grabCursor: false,
        autoplay: true,
        simulateTouch: false,
        pagination: {
          el: '.swiper-pagination.' + navigationVar,
          clickable: true,
        },
        on: {
          slideChangeTransitionStart: changeBtnColor
        }
      });
    });

    $('.coming-soon-module__swiper-pagination-titles span:nth-child(1)').addClass('active');

    $('.coming-soon-module__swiper-slide').each(function (index) {
      const swiperSlideNum = index + 1,
            dataStyle = $(this).attr("data-style");
      $('.swiper-pagination-bullet:nth-child(' + swiperSlideNum + ')').addClass('swiper-pagination-bullet--' + dataStyle);
    });

    function changeBtnColor() {
      const dataStyle = $('.swiper-slide-active').attr("data-style"),
            dataName = $('.swiper-slide-active').attr("data-name");
      $('.coming-soon-module .cta').removeClass('cta--brown cta--green cta--purple').addClass('cta--' + dataStyle);
      $('.coming-soon-module__swiper-pagination-titles span.active').removeClass('active');
      $('.coming-soon-module__swiper-pagination-titles span[data-name="' + dataName + '"]').addClass('active');
    }
  },

  controlFAQ: function () {
    $('.faq-module__question').on('click', function (e) {
      e.preventDefault();
      if($(this).parent('.faq-module__item').hasClass('faq-module__item--open')) {
        $(this).parent('.faq-module__item').removeClass('faq-module__item--open');
        $(this).siblings('.faq-module__answer').slideUp(300);
      } else {
        $(this).parent('.faq-module__item').addClass('faq-module__item--open');
        $(this).siblings('.faq-module__answer').slideDown(300);
      }
    });
  },

  controlModal: function () {
    $('a[href="#stay-informed"], a[href="#subscribe-to-emails"], a[href="#credits"]').on('click', function (e) {
      e.preventDefault();
      var id = $(this).attr('href');
      $('html').addClass('hidden');
      $('.modal-module' + id).addClass('modal-module--open');
    });

    $('.modal-module__close-btn').on('click', function (e) {
      e.preventDefault();
      $('html').removeClass('hidden');
      $('.modal-module--open').removeClass('modal-module--open');
    });
  },

  init: function () {
    this.checkTouchDevice();
    this.controlAnimation();
    this.controlHeader();
    this.initGateway();
    this.hideAgeGate();
    this.controlMainMenu();
    this.getCopyrightYear();
    this.initGSAP();
    this.initSwipers();
    this.controlFAQ();
    this.controlModal();
  },
};

export default App;